import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/lodash-es/_getPrototype.js
// module id = 127
// module chunks = 0